
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  DestinationOrgcodename,
  deviceStatus,
  PdaUsercodename,
  RankingList,
  Scan,
  StatisticalData,
  YtoTable,
} from "@/views/components";
import Form1 from "@/views/scanforacceptpacketnew/Form1.vue";
import Form2 from "./Form2.vue";
import TableHeader from "./TableHeader.vue";
// import FormPic from "./FormPic.vue";
import TableHeaderConfig from "./config";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import RankingList2 from "@/views/components/RankingList/RankingList2.vue";

@Component({
  name: "ScanforAcceptPacketShape2",
  components: {
    Scan2,
    DeviceItems2,
    deviceStatus,
    RankingList,
    RankingList2,
    StatisticalData,
    PdaUsercodename,
    DestinationOrgcodename,
    YtoTable,
    Form1,
    Form2,
    TableHeader,
    Scan,
    // FormPic
  },
})
export default class extends Vue {
  // @Prop() private getForm2Value;
  // @Prop() private ranklistdata;
  @Prop() private statisticalList;
  // @Prop() private deletedatahistory;
  @Prop() private callbackmodel;
  @Prop() private getFormValue;
  @Prop() private errormessage;
  @Prop() private deviceItems;
  @Prop() private inputModel;
  // @Prop() private ytoCode;
  @Prop() private scanAreaCallback;
  @Prop() private selectElementContents;
  @Prop() private rowClassAction;
  @Prop() private showList;
  @Prop() private currentRowChanged;
  // @Prop() private ytocodeget;

  private config = TableHeaderConfig;

  public ytoCode: string = "";

  private ytocodeget(e) {
    console.log("ytocodeget");
    this.$emit("ytocodeget", this.ytoCode, ...arguments);
  }
  private deletedatahistory() {
    debugger;
    let el: any = this.$refs.ytoTable;
    let row = el.getSelectRow();
    if (row) {
      this.$confirm("是否确定要删除此数据？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          try {
            this.$emit('deletedatahistory', row)
          } catch (error) {
            console.log("[错误]:删除失败：" + error.message);
          }
        })
        .catch(() => {
          console.log("取消删除");
        });
    } else {
      this.$message.error("请先选择一条数据");
      return;
    }
  }
}
